module.exports = __webpack_public_path__ + "static/media/nodejs_logo.f28d0807.svg";